import { Controller } from "@hotwired/stimulus"
import Mailcheck from "../../src/mailcheck"

const DOMAINS = [
  "aol.com", "att.net", "comcast.net", "facebook.com", "gmail.com", "gmx.com", "googlemail.com",
  "google.com", "hotmail.com", "hotmail.co.uk", "mac.com", "me.com", "mail.com", "msn.com",
  "live.com", "sbcglobal.net", "verizon.net", "yahoo.com", "yahoo.co.uk", "livertysurf.net",
  "email.com", "fastmail.fm", "games.com", "gmx.net", "hush.com", "hushmail.com", "icloud.com",
  "iname.com", "inbox.com", "lavabit.com", "love.com", "outlook.com", "pobox.com", "protonmail.com",
  "rocketmail.com", "safe-mail.net", "wow.com", "ygm.com",
  "ymail.com", "zoho.com", "yandex.com",
  "bellsouth.net", "charter.net", "cox.net", "earthlink.net", "juno.com",
  "btinternet.com", "virginmedia.com", "blueyonder.co.uk", "freeserve.co.uk", "live.co.uk",
  "ntlworld.com", "o2.co.uk", "orange.net", "sky.com", "talktalk.co.uk", "tiscali.co.uk",
  "virgin.net", "wanadoo.co.uk", "bt.com",
  "sina.com", "qq.com", "naver.com", "hanmail.net", "daum.net", "nate.com", "yahoo.co.jp", "yahoo.co.kr", "yahoo.co.id", "yahoo.co.in", "yahoo.com.sg",
  "yahoo.com.ph",
  "hotmail.fr", "live.fr", "laposte.net", "yahoo.fr", "wanadoo.fr", "orange.fr", "gmx.fr", "sfr.fr", "neuf.fr", "free.fr", "freesurf.fr", "bouygtel.fr",
  "tiscali.fr", "club-internet.fr", "numericable.fr", "cegetel.net", "alice.fr", "aliceadsl.fr", "libertysurf.fr", "freesbee.fr", "ifrance.com",
  "myopera.com", "ovh.net", "bbox.fr", "evhr.net", "gawab.com", "magic.fr", "9online.fr", "nerim.net", "noos.fr", "powermail.fr",
  "gmx.de", "hotmail.de", "live.de", "online.de", "t-online.de", "web.de", "yahoo.de",
  "libero.it", "virgilio.it", "hotmail.it", "aol.it", "tiscali.it", "alice.it", "live.it", "yahoo.it", "email.it", "tin.it", "poste.it", "teletu.it",
  "mail.ru", "rambler.ru", "yandex.ru", "ya.ru", "list.ru",
  "hotmail.be", "live.be", "skynet.be", "voo.be", "tvcablenet.be", "telenet.be",
  "hotmail.com.ar", "live.com.ar", "yahoo.com.ar", "fibertel.com.ar", "speedy.com.ar", "arnet.com.ar",
  "yahoo.com.mx", "live.com.mx", "hotmail.es", "hotmail.com.mx", "prodigy.net.mx",
  "yahoo.com.br", "hotmail.com.br", "outlook.com.br", "uol.com.br", "bol.com.br", "terra.com.br", "ig.com.br", "itelefonica.com.br", "r7.com", "zipmail.com.br",
  "globo.com", "globomail.com", "oi.com.br",
]

export default class extends Controller {
  static targets = ["input", "hint", "suggestion"]

  check() {
    const email = this.inputTarget.value

    Mailcheck.run({
      email,
      domains: DOMAINS,
      topLevelDomains: [],
      suggested: (result) => {
        const domain = email.indexOf("gmail.fr") >= 0 ? "gmail.com" : result.domain
        this.suggestionTarget.textContent = `${result.address}@${domain}`
        this.hintTarget.classList.remove("hidden")
      },
      empty: () => this.hide(),
    })
  }

  correct(event) {
    event.preventDefault()
    this.inputTarget.value = this.suggestionTarget.textContent
    this.hide()
  }

  preventPaste(event) {
    event.preventDefault()
  }

  hide() {
    this.hintTarget.classList.add("hidden")
  }
}
